const LogoData = [

  {
    upperImg:"Icons/apple1.jpg",
    lowerImg:"Icons/apple2.jpeg"
  },
  {
    upperImg:"Icons/twitter1.jpeg",
    lowerImg:"Icons/twitter2.jpg"
  },
  {
    upperImg:"Icons/nike1.jpg",
    lowerImg:"Icons/nike2.jpg"
  }
];
export {LogoData};